// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'folder-nested';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.125 14.063a1.125 1.125 0 0 0 1.125 1.124h1.125M6.188 5.063H9m-7.875 0h2.25m-2.25-1.688v2.813m0 2.812v2.25M9 15.188H6.187m10.126-13.5h-3.375l-.96-.96a.562.562 0 0 0-.398-.165H9.562A.563.563 0 0 0 9 1.125V6.75a.563.563 0 0 0 .563.563h6.75a.562.562 0 0 0 .562-.563v-4.5a.563.563 0 0 0-.563-.563zm0 10.125h-3.375l-.96-.96a.562.562 0 0 0-.398-.165H9.562A.563.563 0 0 0 9 11.25v5.625a.562.562 0 0 0 .563.563h6.75a.562.562 0 0 0 .562-.563v-4.5a.562.562 0 0 0-.563-.563z'
  />
);

export const viewBox = '0 0 18 18';
